import { CarIdentifierWithIcon } from '@components/BookingFlow/Common/CarIdentifierWithIcon';
import { LicensePlate, SalesItemWheelsPickupOptionRecordArray } from '@navio/nsdk';
import { BookingStoreCar } from 'noddi-types';
import { TireHotelPickUpOption } from './TireHotelPickUpOption';

type Props = {
  licensePlate: LicensePlate;
  pickUpOptions: SalesItemWheelsPickupOptionRecordArray;
  /** Resolved by the parent from the draft, so this view never has to handle a car it can't find. */
  car: BookingStoreCar;
};

export const CarWithTirePickUpOptions = ({ licensePlate, pickUpOptions, car }: Props) => {
  const sortedPickUpOptions = [...pickUpOptions].sort((a, b) => a.uiSortOrder - b.uiSortOrder);

  return (
    <div className='flex flex-col gap-5'>
      <CarIdentifierWithIcon car={car} />

      <div className='flex flex-col gap-4'>
        {sortedPickUpOptions.map((pickUpSalesItem) => (
          <TireHotelPickUpOption
            tireHotelSalesItem={pickUpSalesItem}
            licensePlate={licensePlate}
            key={pickUpSalesItem.salesItemId}
          />
        ))}
      </div>
    </div>
  );
};
